module.exports = __webpack_public_path__ + "img/10.3.TP.c5d0bc67.png";